<template>
  <EmailConfirmationModal
    :additionalText="additionalText"
    :bodyText="bodyText"
    :cancelText="cancelText"
    :confirmationText="confirmationText"
    :defaultInputValue="defaultInputValue"
    :handleCancel="handleCancel"
    :handleContinue="handleContinue"
    :headerText="headerText"
    :loading="loading"
    @input="handleChangeEvent"
  />
</template>
<script>

import * as Constants from 'client/util/Constants';
import { mapActions } from 'vuex';
import { notify } from 'client/util';
import EmailConfirmationModal from 'client/systemusers/Modals/EmailConfirmationModal.vue';
import ModalEventBus from 'client/components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const {
  ItemTypeConsts,
  ItemTypeRoutes,
} = Constants;

const { error, success } = Constants.default;

const systemUserModel = 'SystemUserModel';

export default {
  name: 'WelcomeEmailConfirmationModal',

  components: {
    EmailConfirmationModal,
  },

  ModalEventBus,

  notify,

  props: {
    cancelText: {
      default: 'cancel',
      type: String,
    },
    closeAsideOnSubmit: {
      default: true,
      type: Boolean,
    },
    defaultInputValue: {
      default: '',
      type: String,
    },
  },

  data() {
    return {
      activationEmail: '',
      additionalText: 'You may also skip sending this email now, and send it at a later time.',
      bodyText: 'JumpCloud\'s welcome email will be sent to the user\'s company email address. The user will be required to login with the password you specified.',
      confirmationText: 'Welcome Email Destination',
      errorMessage: 'There was an error sending the welcome email. Please try again. If problem persists, please contact support.',
      headerText: 'Welcome Email',
      loading: false,
      successMessage: 'Welcome email sent successfully!',
    };
  },

  beforeDestroy() {
    this.resetItem();
  },

  mounted() {
    this.fetchItem();
    this.handleChangeEvent(this.defaultInputValue);
  },

  methods: {
    ...mapActions(systemUserModel, [
      'activateWithEmail',
      'fetchItem',
      'resetItem',
    ]),

    handleCancel() {
      this.handleFinish();
    },

    async handleChangeEvent(val) {
      this.activationEmail = val;
    },

    async handleContinue() {
      this.loading = true;
      try {
        await this.activateWithEmail(this.activationEmail);
        this.$options.notify(success, this.successMessage);
      } catch {
        this.$options.notify(error, this.errorMessage);
      }
      this.loading = false;
      this.handleFinish();
    },

    handleFinish() {
      this.$options.ModalEventBus.close();
      if (this.closeAsideOnSubmit) {
        Util.redirect(ItemTypeRoutes[ItemTypeConsts.systemUser]);
      }
    },
  },
};
</script>
